var _excluded = ["component", "user", "feature", "path", "publicComponent", "notLoggedInComponent", "openOnPreRelease"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { isPreRelease } from '@finect/front-utils/isPreRelease';
import { PublicBeta } from './PublicBeta';
import { LoginRedirect } from './LoginRedirect';
var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.user
  };
};
var PublicBetaRoute = function PublicBetaRoute(_ref) {
  var Scene = _ref.component,
    user = _ref.user,
    feature = _ref.feature,
    path = _ref.path,
    _ref$publicComponent = _ref.publicComponent,
    PublicComponent = _ref$publicComponent === void 0 ? PublicBeta : _ref$publicComponent,
    NotLoggedInComponent = _ref.notLoggedInComponent,
    _ref$openOnPreRelease = _ref.openOnPreRelease,
    openOnPreRelease = _ref$openOnPreRelease === void 0 ? true : _ref$openOnPreRelease,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _user$features = user.features,
    features = _user$features === void 0 ? [] : _user$features;
  return React.createElement(Route, _extends({}, rest, {
    render: function render(props) {
      return user.isLoggedIn ? features.includes(feature) || isPreRelease && openOnPreRelease ? React.createElement(Scene, props) : React.createElement(PublicComponent, props) : NotLoggedInComponent ? React.createElement(NotLoggedInComponent, props) : React.createElement(LoginRedirect, _extends({
        from: path
      }, props));
    }
  }));
};
export default connect(mapStateToProps, null)(PublicBetaRoute);